import { useEffect, type ReactNode } from 'react';

import { applyDesignTokens, clearDesignTokens } from '@/lib/design-tokens.js';
import { useHandshakeContext } from './HandshakeContext.js';

/**
 * Applies the design tokens from the handshake to `:root` CSS variables so
 * every ShadCN primitive picks up the tenant's brand colour, font and radius.
 */
export function TenantTheme({ children }: { children: ReactNode }) {
  const { designTokens } = useHandshakeContext();

  useEffect(() => {
    if (!designTokens) return;
    applyDesignTokens(designTokens);
    return () => clearDesignTokens();
  }, [designTokens]);

  return <>{children}</>;
}
